import { ChipFilterButton } from './styles';

type ChipFilterProps = {
  label: string;
  active?: boolean;
  onClick: () => void;
};

const ChipFilter = ({ label, active = false, onClick }: ChipFilterProps) => (
  <ChipFilterButton type="button" active={active} onClick={onClick}>
    {label}
  </ChipFilterButton>
);

export default ChipFilter;
